import { render, staticRenderFns } from "./author.vue?vue&type=template&id=3991fd94&scoped=true"
import script from "./author.vue?vue&type=script&lang=js"
export * from "./author.vue?vue&type=script&lang=js"
import style0 from "./author.vue?vue&type=style&index=0&id=3991fd94&prod&lang=scss&scoped=true"
import style1 from "./author.vue?vue&type=style&index=1&id=3991fd94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3991fd94",
  null
  
)

export default component.exports